<!-- @Version: 1.1.0 -->
<div class="page-wrapper" cdkTrapFocus>
   <div class="center">
      <h3 [attr.color]="path + TRANSLATE_PATH.SPINNER_COLOR | translateDesign">{{path + TRANSLATE_PATH.SPINNER_TITLE | translateDesign}}</h3>
      <ng-container *ngIf="(path + TRANSLATE_PATH.SPINNER_ICON | translateDesign) == path + TRANSLATE_PATH.SPINNER_ICON || (path + TRANSLATE_PATH.SPINNER_ICON | translateDesign) == ''">
         <mat-progress-spinner diameter="100" 
            mode="indeterminate"
            [color]="(path + TRANSLATE_PATH.SPINNER_COLOR | translateDesign)">
         </mat-progress-spinner>
      </ng-container>
      <ng-container *ngIf="(path + TRANSLATE_PATH.SPINNER_ICON | translateDesign) != path + TRANSLATE_PATH.SPINNER_ICON && (path + TRANSLATE_PATH.SPINNER_ICON | translateDesign) != ''">
         <mat-icon [color]="path + TRANSLATE_PATH.SPINNER_COLOR | translateDesign" data-width="fit-content" class="special-page">{{path + TRANSLATE_PATH.SPINNER_ICON | translateDesign}}</mat-icon>
      </ng-container>
      <h4 [attr.color]="path + TRANSLATE_PATH.SPINNER_COLOR | translateDesign">{{path + TRANSLATE_PATH.SPINNER_MESSAGE | translateDesign}}</h4>
   </div>
</div>